import React, { Dispatch, SetStateAction } from "react";
import { useSelector } from "react-redux";

import { RootState } from "src/redux/reducers";
import {
  HandleAddFieldsProps,
  HandleRemoveFieldsProps,
  HandleUpdateTemplateValueParams,
  Template,
} from "../types";
import FieldsTab from "../components/FieldsTab";

interface TemplateManagerOverviewTabProps {
  editedTemplate: Template;
  handleUpdateTemplateValue: (params: HandleUpdateTemplateValueParams) => void;
  handleAddFields: (params: HandleAddFieldsProps) => void;
  handleRemoveFields: (params: HandleRemoveFieldsProps) => void;
  setEditedTemplate: Dispatch<SetStateAction<Template | null>>;
  syncLocalTemplateWithServer: (uuid: string) => Promise<void>;
}

export default function TemplateManagerOverviewTab({
  editedTemplate,
  handleUpdateTemplateValue,
  handleAddFields,
  handleRemoveFields,
  setEditedTemplate,
  syncLocalTemplateWithServer,
}: TemplateManagerOverviewTabProps) {
  const {
    settingsReducer: { globalProjectMetaFields },
  } = useSelector((state: RootState) => state);

  return (
    <FieldsTab
      editedTemplate={editedTemplate}
      setEditedTemplate={setEditedTemplate}
      handleUpdateTemplateValue={handleUpdateTemplateValue}
      handleAddFields={handleAddFields}
      handleRemoveFields={handleRemoveFields}
      fieldType="project"
      key="project"
      fields={globalProjectMetaFields}
      syncLocalTemplateWithServer={syncLocalTemplateWithServer}
    />
  );
}
